import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=d3f88c40&scoped=true"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"
import style0 from "./_slug.vue?vue&type=style&index=0&id=d3f88c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f88c40",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogArticleHeader: require('/home/rohit/Documents/GitHub/aibuddha-website/components/blog/article/header.vue').default,BlogFeatured: require('/home/rohit/Documents/GitHub/aibuddha-website/components/blog/Featured.vue').default,BlogSubscribe: require('/home/rohit/Documents/GitHub/aibuddha-website/components/blog/Subscribe.vue').default})
